import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';

const endpoint = 'oms/v1/aggregated-sheets/reports';
export const testAggregatedSheetsRelationsEndpointIdentifier = endpoint;

type Recipients = {
  to: string[];
  cc?: string[];
  bcc?: string[];
};

interface BodyType {
  recipients?: Recipients;
}

type TData = Record<string, any>;
type TError = AxiosError;

type TVariables = {
  aggSheetId: number;
  body: BodyType;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useTestAggSheetsRelationsApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ aggSheetId, body }: TVariables) => {
    const fullEndpoint = `${endpoint}/${aggSheetId}/test`;

    try {
      const { data } = await http.post(fullEndpoint, body);

      toast({
        description: 'Test report was created successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
